// Character input limits
export const CHATBOT_CHAR_LIMIT = 1000;
export const CHATBOT_NEAR_LIMIT_RATIO = 0.9;
export const CHATBOT_TEXTAREA_MAX_HEIGHT = 120;

// Request limit constants
export const CHATBOT_DEFAULT_REQUEST_LIMIT = 25;
export const CHATBOT_LOW_REQUEST_THRESHOLD = 10; // Show warning when requests remaining <= this value

// UI text
export const CHATBOT_TITLE = 'SellerHub Assistant';
export const CHATBOT_WELCOME_TITLE = 'Welcome to SellerHub Assistant!';
export const CHATBOT_WELCOME_TEXT = 'Ask me anything about products, orders, inventory, and more.';
export const CHATBOT_INPUT_PLACEHOLDER = 'Type your question...';

// ARIA labels
export const CHATBOT_CLOSE_ARIA_LABEL = 'Close chat';
export const CHATBOT_SEND_ARIA_LABEL = 'Send message';

// Response / error messages
export const CHATBOT_FALLBACK_RESPONSE = 'Sorry, I could not process your request.';
export const CHATBOT_ERROR_TOAST = 'Failed to get response from chatbot';
export const CHATBOT_ERROR_MESSAGE = 'Sorry, I encountered an error. Please try again.';
export const CHATBOT_LIMIT_EXCEEDED_MESSAGE = 'Daily chat limit reached. Please try again tomorrow.';

// Character counter display
export const CHATBOT_CHAR_LIMIT_WARNING = 'Character limit reached! Keep it concise.';

// AI disclaimer
export const CHATBOT_AI_DISCLAIMER = 'AI can make mistakes. Please verify important information.';

// Colors not covered by the theme
export const CHATBOT_COLOR_AT_LIMIT = '#d32f2f';
export const CHATBOT_COLOR_NEAR_LIMIT = '#f57c00';
export const CHATBOT_COLOR_LOW_REQUEST = '#f57c00';

// Typing indicator dot delays (seconds)
export const CHATBOT_TYPING_DOT_DELAYS = [0, 0.2, 0.4] as const;

// Icon font sizes
export const CHATBOT_AVATAR_ICON_SIZE = 18;

// Inline style values
export const CHATBOT_MESSAGE_LINE_HEIGHT = '1.6';
